import { ReceptionistSettingsView, ReportsTopBarActions } from '@elva/ui';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function SettingsPage() {
  usePageTopBar({
    actions: <ReportsTopBarActions />,
  });

  return (
    <div className="-m-6 flex min-h-full flex-1">
      <ReceptionistSettingsView />
    </div>
  );
}
